import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import { DealFileAttachment, DealFileAttachmentClient, ModuleEnum } from "@src/apis/ModularClient";

export class DealFileAttachmentHelper extends BaseService<DealFileAttachment, number> {
  static $inject = [
    "$http",
    "$cookies",
    "$rootScope",
    "$q",
    "$timeout",
    "BroadcastService",
    "DealFileAttachmentClient",
  ];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
    private dealFileAttachmentClient: DealFileAttachmentClient,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/dealfileattachment";
    this.$broadcastBusinessNameSingular = "dealfileattachment";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  private uploadSingleFile(
    file: File,
    objectid: number,
    module?: ModuleEnum,
    caseLenderId?: number,
    dealClientId?: number,
    onProgress?: (percent: number) => void,
  ) {
    let defer = this.$q.defer<DealFileAttachment>();

    this.dealFileAttachmentClient
      .getAmazonFileUploadUri(file.name, file.type, objectid, module, caseLenderId, dealClientId)
      .then(async (fileattach: DealFileAttachment) => {
        await this.$http({
          method: "PUT",
          url: fileattach.tempUploadURL,
          data: file,
          headers: { "Content-Type": file.type },
          uploadEventHandlers: {
            progress(evt: any) {
              if (onProgress) {
                onProgress(100 * (evt.loaded / evt.total));
              }
            },
          },
        });
        return fileattach;
      })
      .then((fileattach: DealFileAttachment) => {
        defer.resolve(fileattach);
      })
      .catch((err) => {
        defer.reject(err);
      });

    return defer.promise;
  }

  UploadFileListInSync(
    files,
    uploadingFiles: FileUploadProgressDTO[],
    objectid: number,
    fileLstOutput: DealFileAttachment[],
    module?: ModuleEnum,
    caseLenderId?: number,
    dealClientId?: number,
  ): ng.IPromise<string> {
    let defer = this.$q.defer<string>();
    var file = files.pop();
    if (!uploadingFiles) {
      uploadingFiles = [];
    }
    if (file) {
      let tmpfile: FileUploadProgressDTO = {
        uploadingFile: file.name,
        uploadPercent: 0,
      };
      uploadingFiles.push(tmpfile);
      this.uploadSingleFile(file, objectid, module, caseLenderId, dealClientId, (p) => {
        tmpfile.uploadPercent = p;
      })
        .then((fileattach) => {
          //file now sent up
          //save attachment record to srever
          this.dealFileAttachmentClient.addUpdateReturnOnlyID(fileattach).then((id) => {
            //append to list of files
            fileattach.id = id;
            fileLstOutput.push(fileattach);
            //remove the object
            if (uploadingFiles) {
              uploadingFiles.splice(uploadingFiles.indexOf(tmpfile));
              //hide uploads of all done
              if (uploadingFiles.length === 0) {
                uploadingFiles = null;
              }
            }
          });
          // this.$scope.$apply();
        })
        .catch((response) => {
          if (uploadingFiles) {
            uploadingFiles.splice(uploadingFiles.indexOf(tmpfile));
          }
          //hide uploads of all done
          if (uploadingFiles.length === 0) {
            uploadingFiles = null;
          }
        })
        .finally(() => {
          this.UploadFileListInSync(files, uploadingFiles, objectid, fileLstOutput, module, caseLenderId, dealClientId);
        });
      return defer.promise;
    } else {
      return this.$q.resolve("No files to upload.");
    }
  }
}
